var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCCNSW)?_c('login-ccnsw'):_c('login-default')
}
var staticRenderFns = []

export { render, staticRenderFns }